var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"slice-body"},_vm._l((_vm.slices),function(slice,i){return (_vm.has(slice))?_c(_vm.templates[slice.type],_vm._g(_vm._b({key:`slice${i}`,tag:"component",attrs:{"slice":slice,"index":i}},'component',_vm.$attrs,false),_vm.$listeners)):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }